import React from 'react';
import { FormattedMessage } from 'react-intl';

import { noop } from 'ui-components/default-props/noop';
import { FlexColumn } from 'ui-components/components/flex';

import { REGULATED_CONTENT_TYPES, REGULATED_CONTENT_TYPE_NONE_VALUE } from './regulated-content-types';
import { regulatedContentType } from '../../../../../services/other-shipping-options/constants';
import { messages } from './messages';
import { SimpleDropdown } from '../../../../../components/simple-dropdown/index';

/**
 * RegulatedContentTypeDropdown component props
 * @typedef {object} RegulatedContentTypeDropdownProps
 * @property {string | null} [optionData=null] - identifier of the other option that we are managing with the dropdown
 * @property {(arg: { id: string, value: string|null, checked: boolean }) => void} [updateOption] - callback to call when there is a change in the dropdown
 */

/**
 * Dropdown component for selecting regulated content type
 * @param {RegulatedContentTypeDropdownProps} props - The component props
 * @returns {JSX.Element} The rendered RegulatedContentTypeDropdown
 */
export const RegulatedContentTypeDropdown = ({ optionData = '', updateOption = noop }) => {
  // Treat 'None', null, and empty string as "not selected"
  const isNoneValue = !optionData || optionData === REGULATED_CONTENT_TYPE_NONE_VALUE;
  const normalizedOptionData = isNoneValue ? '' : optionData;
  const selectedOption = REGULATED_CONTENT_TYPES.find((option) => option.id === normalizedOptionData);
  const optionsWithPlaceholder = [{ id: '', label: messages.regulatedContentTypeNotSelected }, ...REGULATED_CONTENT_TYPES];
  const onChange = (value) => {
    const normalizedValue = value || '';
    updateOption({
      id: regulatedContentType,
      value: normalizedValue,
      checked: !!normalizedValue,
    });
  };
  return (
    <FlexColumn>
      <SimpleDropdown
        defaultTitle={<FormattedMessage {...messages.regulatedContentTypeNotSelected} />}
        items={optionsWithPlaceholder.map((option) => ({
          key: option.id,
          name: <FormattedMessage {...option.label} />,
        }))}
        label={<FormattedMessage {...messages.regulatedContentTypeLabel} />}
        onItemSelected={onChange}
        selectedItemKey={selectedOption?.id}
      />
    </FlexColumn>
  );
};
